export default __webpack_public_path__ + "static/1870-2000_030-d9b62a54f7b12e211b532f8f17c46f6a.jpg";